const NotificationMessage = "[NOTIFICATION MESSAGE]";

export const ADD_MESSAGES = `${NotificationMessage} Add`;
export const REMOVE_MESSAGE = `${NotificationMessage} Delete`;

export const addNotificationMessage = (method, payload) => ({
    type: ADD_MESSAGES,
    payload: {
        data: {
            key: (new Date().getTime() + Math.random()),
            method,
            payload
        }
    }
});

export const addDefaultNotificationMessage = (method, key, type, message, payload) => ({
    type: ADD_MESSAGES,
    payload: {
        data: {
            key: (new Date().getTime() + Math.random()),
            method,
            payload: {
                key,
                type,
                message,
                payload
            },
        }
    }
});

export const removeNotificationMessage = (notificationMessage) => ({
    type: REMOVE_MESSAGE,
    payload: {
        data: notificationMessage
    }
});

